<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="isLoaded" :caption="isLoaded  ? 'Показать ' + this.topCount : loadedPages === 0 ? 'Загрузить' : 'Еще'" :expandable="!((totalPages == loadedPages) && (this.topCount > this.items.length) && isLoaded)">
      <div
        v-show="isLoading && loadedPages < 0"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!(isLoading && loadedPages == 0)">
        <tr><td align="left" colspan="2"> История просмотров</td></tr> 
        <template v-for="item in items">
          <v-layout row>
          <v-flex pb-0>{{item.accountNameShort}}</v-flex><v-flex pb-0 align-end>{{formats.blank(item.created, formats.formatDateTime)}}</v-flex>          
        </v-layout>
        </template>      
      </div>  
    </v-panel-title>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import apimix from '../common/apimix'
  import vPanelTitle from '../info/PanelTitle'

  export default {
    name: 'v-visit-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      items: [],
      totalPages: 0,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false,
      actions () {
        return new Map([
          ['OTHER', 'Неизвестная операция'],
          ['LOGIN', 'вход в систему']
        ])
      }
    }),
    props: {
      refCode: {
        type: String,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      },
      topCount: {
        type: Number,
        default: 2
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      }
    },
    methods: {
      switchItems () {
        if (!this.isLoaded) {
          this.fetchItems()
        } else {
          this.isLoaded = false
          this.loadedPages = 1
          this.items = this.topItems
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка посещений '})
        }
        server.apiGetParams(
          '/api/me/companies/' + id + '/visits',
          {
            size: this.topCount,
            page: this.loadedPages
          },
          cb,
          cbError)
      },
      fetchItems () {
        if (!this.isLoading && this.refCode && this.getProfileHaveClient) {
          // this.items = []
          this.isLoading = true
          this.getItems(this.refCode, (data) => {
            this.items = this.items.concat(data.content)
            this.totalPages = data.totalPages
            this.loadedPages = data.totalPages > data.number ? data.number + 1 : data.totalPages
            this.isLoading = false
            this.isLoaded = (this.totalPages === this.loadedPages)
          })
        }
      }
    }
  }

</script>
<style>
.align-end{
  text-align: right;
}
</style>






// WEBPACK FOOTER //
// VisitPanel.vue?6fa43557